export default __webpack_public_path__ + "static/media/All towers.0df30a37.png";